import React from "react";
import * as Icons from "lucide-react";
import { processSteps } from "../mock";

export default function Process() {
  return (
    <section id="process" className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="inline-block text-teal-600 font-bold uppercase tracking-widest text-xs bg-teal-50 px-4 py-1.5 rounded-full mb-4">Our Global Shipping &amp; Logistics Process</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">From Your Doorstep to the World</h2>
          <p className="mt-3 text-slate-600">We maintain cold-chain integrity and medical compliance at every node of the transit flow.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {processSteps.map((s) => {
            const Icon = Icons[s.icon] || Icons.Box;
            return (
              <div key={s.no} className="relative bg-slate-50 rounded-2xl p-6 border border-slate-100 overflow-hidden hover:border-teal-200 transition-colors">
                <span className="absolute -top-3 -right-2 text-7xl font-extrabold text-slate-100 select-none">{s.no}</span>
                <div className="relative">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-teal-500 to-blue-600 text-white flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7" />
                  </div>
                  <p className="text-xs font-bold text-teal-600 uppercase tracking-widest mb-1">{s.step}</p>
                  <h4 className="font-bold text-slate-900 mb-2">{s.title}</h4>
                  <p className="text-sm text-slate-500 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
